import tokens from '@kluein/design-tokens';
import { Box, TextArea, TextInput } from '@kluein/klue-ui';
import styled, { css } from 'styled-components';

export const StyledAskKlueBadge = styled(Box)<{
  $borderColor: string;
  $backgroundColor: string;
  $isClickable?: boolean;
}>`
  width: fit-content;
  height: fit-content;
  cursor: default;
  border: 1px solid ${({ $backgroundColor }) => $backgroundColor};
  &:focus,
  &:focus-visible {
    border: 1px solid ${({ $backgroundColor }) => $backgroundColor};
    outline-style: none;
    box-shadow: none;
  }

  ${({ $isClickable, $borderColor }) => {
    if ($isClickable) {
      return css`
        cursor: pointer;
        &:hover {
          border: 1px solid ${$borderColor};
        }
      `;
    }
  }}
`;

export const StyledInputDashboardBox = styled(Box)<{
  $isExpanded: boolean;
  $isSmallScreen: boolean;
  $isClickableButton?: boolean;
}>`
  height: 45px;
  background-color: ${tokens.color.neutral.white.main};
  border-color: ${tokens.color.secondary[500]};
  outline: none;
  box-shadow: 0px 2px 8px 0px #f0e7ff;
  width: 300px;
  transition: width 0.4s ease;
  &:hover {
    border-color: ${tokens.color.secondary[500]};
    box-shadow: 0px 2px 8px 0px #f0e7ff;
  }

  &:focus,
  &:focus-visible {
    border-color: ${tokens.color.secondary[500]};
    outline-style: none;
    box-shadow: none;

    &:hover {
      border-color: ${tokens.color.secondary[500]};
      box-shadow: 0px 2px 8px 0px #f0e7ff;
    }
  }

  ${({ $isExpanded, $isSmallScreen, $isClickableButton = false }) => {
    if ($isSmallScreen) {
      return css`
        width: auto;
      `;
    }

    if ($isClickableButton && !$isSmallScreen) {
      return css`
        width: 345px;
      `;
    }

    if ($isExpanded && !$isSmallScreen) {
      return css`
        width: 650px;
      `;
    }
  }}
`;

export const StyledInputDashboard = styled(TextInput)`
  background-color: ${tokens.color.neutral[100]};
  height: 100%;
  min-height: 42px;
  border: none;
  border-radius: 0;
  color: ${tokens.color.neutral[800]};
  padding-left: ${tokens.spacing.small};
  font-size: ${tokens.fontSize.bodyFont.medium};
  &:hover,
  &:focus {
    border: none;
  }
`;

export const StyledInput = styled(TextArea)<{
  $isResizable?: boolean;
  $preservedHeight?: number | null;
}>`
  background-color: transparent;
  border: none;
  resize: ${(props) => (props.$isResizable ? 'vertical' : 'none')};
  padding: 0;
  height: ${(props) =>
    props.$preservedHeight ? `${props.$preservedHeight}px` : 'auto'};
  max-height: ${(props) => (props.$isResizable ? 'min(33vh, 500px)' : 'auto')};
  min-height: 40px;
  width: 100%;
  flex-grow: 1;
  color: ${tokens.color.primary.contrastlight};
  outline: none;
  overflow: auto;
  &:hover,
  &:focus,
  &:focus-visible {
    border: none;
    outline-style: none;
    box-shadow: none;
    color: ${tokens.color.primary.contrastlight};
  }
  &::placeholder {
    color: ${tokens.color.neutral[800]};
  }
  &:focus:not(div):not([class*='nectar']) {
    outline: none !important;
  }
`;
